import { Box } from "@mui/material";

type Week = { weekStart: string; games: number; missed: number };

/** Twelve tiny weekly bars: height is the share of counted games with a miss; weeks without games stay flat. */
export const Sparkline = ({ weeks, label }: { weeks: readonly Week[]; label: string }) => (
  <Box
    role="img"
    aria-label={label}
    sx={{ display: "grid", gridAutoFlow: "column", gridAutoColumns: "1fr", alignItems: "end", gap: "2px", height: 22 }}
  >
    {weeks.map((week) => (
      <Box
        key={week.weekStart}
        data-spark={week.games === 0 ? "empty" : week.missed ? "missed" : "clean"}
        sx={{
          height: week.games === 0 ? "2px" : week.missed ? `${Math.max(20, (100 * week.missed) / week.games)}%` : "3px",
          bgcolor: week.games === 0 ? "divider" : week.missed ? "secondary.main" : "success.main",
        }}
      />
    ))}
  </Box>
);
